import { apiService } from "../api/services/apiService";
import {
  DEFAULT_AGENT_RUNNER_BASE_PATH,
  runnerAgentPathSegment,
  stripTrailingSlash,
} from "./agentRunnerAgents";

const cache = new Map<string, Promise<string>>();

function compileFallbackBase(): string {
  const fromEnv = import.meta.env.VITE_AGENT_API_BASE?.trim();
  return stripTrailingSlash(fromEnv || DEFAULT_AGENT_RUNNER_BASE_PATH);
}

/**
 * Resolved agent-runner prefix including the registered runner agent name,
 * e.g. `/api/v2/sami/agent/sami_concierge_agent`.
 * CMS `resolvedAgentRunnerBase` is the gateway prefix; workspace `agentId` maps to YAML `agent_name`.
 */
export async function agentApiBase(agentId: string): Promise<string> {
  let pending = cache.get(agentId);
  if (!pending) {
    pending = resolveAgentApiBase(agentId);
    cache.set(agentId, pending);
  }
  return pending;
}

export function clearAgentApiBaseCache(): void {
  cache.clear();
}

async function resolveAgentApiBase(agentId: string): Promise<string> {
  try {
    const resolved = await apiService.resolvedAgentRunnerBase(agentId);
    if (resolved?.trim()) {
      return `${stripTrailingSlash(resolved.trim())}/${runnerAgentPathSegment(agentId)}`;
    }
  } catch {
    // CMS unavailable or unauthenticated — fall through to Vite / compile default.
  }
  return `${compileFallbackBase()}/${runnerAgentPathSegment(agentId)}`;
}
